/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import classnames from "classnames"
import {State, StepStatus} from "ui/feature/root/FormReducer";
import styles from "./UploadWorkspaceFileUploadStatusOverlay.module.scss";
import {faCheck, faRotate, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Header2 from "ui/kit/typography/Header2";
import IconOverlay from "ui/feature/root/common/IconOverlay";

interface Props {
    className?: string;
    state: State;
    file: File;
}

const UploadWorkspaceFileUploadStatusOverlay: React.FC<Props> = ({className, state, file}) => {

    const modeBasedOnState: "success" | "in_progress" | "error" = React.useMemo(() => {
        switch (state.uploadStepStatus) {
            case StepStatus.IN_PROGRESS:
                return "in_progress";
            case StepStatus.NEEDS_EDIT:
                return "in_progress";
            case StepStatus.SUCCESS:
                return "success";
            case StepStatus.ERROR:
                return "error";
        }
    }, [state.uploadStepStatus]);

    const iconDefinitionBasedOnState = React.useMemo(() => {
        switch (state.uploadStepStatus) {
            case StepStatus.NEEDS_EDIT:
            case StepStatus.IN_PROGRESS:
                return faRotate;
            case StepStatus.SUCCESS:
                return faCheck;
            case StepStatus.ERROR:
                return faXmark;
        }
    }, [state.uploadStepStatus])

    const componentBasedOnState = React.useMemo(() => {
        switch (state.uploadStepStatus) {
            case StepStatus.IN_PROGRESS:
                const progress = state.fileToUploadProgressLookup[file.name];
                if (!progress) {
                    return <FontAwesomeIcon icon={iconDefinitionBasedOnState} size={"3x"}/>
                } else {
                    const rounded = Math.round(progress * 100)
                    return <Header2 className={styles.percentageText}>{rounded}%</Header2>;
                }
            case StepStatus.ERROR:
            case StepStatus.SUCCESS:
            case StepStatus.NEEDS_EDIT:
                return <FontAwesomeIcon icon={iconDefinitionBasedOnState} size={"3x"}/>
        }
    }, [state.uploadStepStatus, state.fileToUploadProgressLookup, file.name, iconDefinitionBasedOnState]);

    if (state.uploadStepStatus === StepStatus.NEEDS_EDIT) {
        return null; // no overlay in the needs edit case
    }

    return (
        <div className={classnames(className, styles.container)}>
            <IconOverlay mode={modeBasedOnState}>
                {componentBasedOnState}
            </IconOverlay>
        </div>
    );
}

export default UploadWorkspaceFileUploadStatusOverlay